<template>
    <v-tab-item
        value="columns"
        transition="false"
    >
        <v-tab-item value="columns">
            <v-row>
                <v-card-text>
                    Click and hold the symbol
                    <v-icon medium>
                        drag_indicator
                    </v-icon> to drag and drop columns into the preferred order
                </v-card-text>               
                <v-col
                    class="d-flex"
                    cols="12"
                    sm="4"
                >
                    <v-select
                        v-model="addedColumn"
                        :items="columnItems"
                        label="Add Column"
                        item-text="label"
                        item-value="value"
                        dense
                        outlined
                        multiple
                        @change="UpdateColumnItems"
                        @blur="clearAddedColumn"
                    >
                        <template v-slot:prepend-item>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-text-field
                                        v-model="searchTerm"
                                        outlined
                                        dense
                                        solo
                                        append-icon="mdi-magnify"
                                        placeholder="Search"
                                        @input="searchColumn"
                                    />
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                        <template v-slot:selection="{ item, index }">
                            <v-chip v-if="index === 0">
                                <span>{{ item.value }}</span>
                            </v-chip>
                            <span
                                v-if="index === 1"
                                class="grey--text text-caption"
                            >
                                (+{{ addedColumn.length - 1 }} others)
                            </span>
                        </template>
                    </v-select>
                </v-col>
            </v-row>
            <v-data-table
                id="main-tickets-table"
                ref="main-tickets-table"
                :headers="columnHeaders"
                :items="columnData"
                :hide-default-footer="true"
                disable-pagination
            >
                <template v-slot:body="props">
                    <draggable
                        :list="props.items"
                        tag="tbody"
                        @change="updateOrder($event, props)"
                    >
                        <tr
                            v-for="(item, index) in props.items"
                            :key="index"
                        >
                            <td>
                                <v-icon
                                    medium
                                    style="cursor: pointer"
                                >
                                    drag_indicator
                                </v-icon>
                            </td>
                            <td>{{ item.name }}</td>
                            <td>{{ item.description }}</td>
                            <td>
                                <v-icon
                                    medium
                                    @click="removeColumn(item.label)"
                                >
                                    close
                                </v-icon>
                            </td>
                        </tr>
                    </draggable>
                </template>
            </v-data-table>
        </v-tab-item>
    </v-tab-item>
</template>
<script>
import draggable from 'vuedraggable';
export default {
    components: {
        draggable,
    },
    props: {
        columns: {
            type: String,
            default: () => '',
        },
    },
    data(){
        return{
            columnData: [],
            columnList: [],
            loading: false,

            columnHeaders: [
                { text: 'Reorder', sortable: false },
                { text: 'Column', value: 'name' },
                { text: 'Discription', value: 'description' },
                {
                    text: 'Remove',
                    value: 'Remove',
                    sortable: false,
                },
            ],
            columnItems: [],
            columnCopy: [],
            searchTerm: '',
            addedColumn: [],
            currentFields: [],
            currentFieldsData: [],
        };
    },
    watch: {
        columns(){
            this.currentFields = this.columns.split(',');
            this.loadColumns();
        }
    },
    async mounted() {    
        this.loadSelectItems();
        this.loadColumns();       
    },
    methods:{
        loadSelectItems(){
            this.columnList = this.$store.getters.columnsCatalog;
            // Filter columns that are used
            this.columnList = this.columnList.filter((f) => f.used === 1);
            // shows in dropdown
            this.columnItems = this.columnList
                .filter((f) => !this.currentFields.includes(f.sql_col_name))
                .map((m) => ({
                    label:
          m.label != m.description ? m.label + ':' + m.description : m.label,
                    value: m.label,
                })).sort((a, b) => a.label.localeCompare(b.label));

            this.columnCopy = this.columnItems;
        },
        loadColumns(){
            const currentFields = this.columns;
            this.currentFields = currentFields? currentFields.split(','): [];
            this.columnCopy = this.columnItems;

            this.columnData = this.currentFields.map((c) =>
                this.columnList.find((l) => l.sql_col_name === c)
            );
            this.$emit('updateColumnData', this.columnData);
            this.currentFieldsData = [...this.columnData];

        },
        clearAddedColumn() {            
            this.addedColumn = [];          
        },
        updateOrder(ele) {
            const columnData = [...this.columnData];
            columnData.splice(
                ele.moved.newIndex,
                0,
                columnData.splice(ele.moved.oldIndex, 1)[0]
            );
            this.columnData = [...columnData];
            this.$emit('updateColumnData', this.columnData);
        },
        removeColumn(label) {
            let columnItem = this.columnData
                .filter((data) => data.label == label)
                .map((m) => m)[0];
            let columnIndex = this.columnData.findIndex(
                (data) => data.label == label
            );
            this.columnData.splice(columnIndex, 1);

            this.columnItems.push({
                label:
          columnItem.label != columnItem.description
              ? columnItem.label + ':' + columnItem.description
              : columnItem.label,
                value: columnItem.label,
            });
            this.columnCopy.push({
                label:
          columnItem.label != columnItem.description
              ? columnItem.label + ':' + columnItem.description
              : columnItem.label,
                value: columnItem.label,
            });

            // update the current field
            this.currentFieldsData = [...this.columnData];
        },
        searchColumn() {
            if (this.searchTerm) {
                this.columnItems = this.columnCopy.filter((column) => {
                    return (
                        column.label.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1 ||
                        column.value.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1
                    );
                });
            }
        },
        UpdateColumnItems() {
            let self = this;
            this.columnData = [...this.currentFieldsData];
            if (self.addedColumn.length > 0) {
                self.addedColumn.forEach((element) => {
                    let columnObj = self.columnList.find((x) => x.label == element);
                    if (columnObj) {
                        self.columnData.push(columnObj);
                    }
                });
            }
            this.$emit('updateColumnData', self.columnData);
        },
    }
};
</script>